import {
  DataQualityIssue,
  DataQualityIssues,
  DqiCategory,
} from "src/global/schemas/expectations/expectation-metadata-data-quality-issues"
import { Icon, IconTypes } from "src/global/ui/Icon/Icon"
import { Image } from "src/global/ui/Image"

type DqiCategoryProps = { icon: IconTypes } | { image: "numeric" | "code" }

const svgDqiCoverageIconStyle = (size: string, color: string) => ({ height: size, width: size, fill: color })

const defaultDqiCategory: DqiCategoryProps = {
  icon: "question",
}

const dqiCategoryNametoDqiCategory: Record<DqiCategory, DqiCategoryProps> = {
  Schema: {
    icon: "fileNetwork",
  },
  Volume: {
    icon: "chartBar",
  },
  Completeness: {
    icon: "documentInfo",
  },
  Uniqueness: {
    icon: "keyholeCircle",
  },
  Validity: {
    icon: "fileCheckAlt",
  },
  Numeric: {
    image: "numeric",
  },
  SQL: {
    image: "code",
  },
  "Multi-source": {
    icon: "adjustCircle",
  },
  Other: defaultDqiCategory,
}

type DqiCategoryIconProps = {
  dqiCategory: DqiCategory
  color: string
  size: "32px" | "24px" | "22px" | "20px" | "16px" | "12px" | "10px" | "8px" | "6px" | "4px" | "2px"
  ariaLabel: string
}

const hasIcon = (dqiCategory: DqiCategoryProps) => {
  return "icon" in dqiCategory
}

export const DqiCategoryIcon = (props: DqiCategoryIconProps) => {
  const dqiCategory = DataQualityIssues.includes(props.dqiCategory as DataQualityIssue)
    ? dqiCategoryNametoDqiCategory[props.dqiCategory as DataQualityIssue]
    : defaultDqiCategory
  if (hasIcon(dqiCategory)) {
    return (
      <Icon
        name={dqiCategory.icon}
        color={props.color}
        size={props.size}
        aria-label={props.ariaLabel}
        lineHeight={props.size}
      />
    )
  }
  return (
    <Image
      type={dqiCategory.image}
      svgProps={svgDqiCoverageIconStyle(props.size, props.color)}
      aria-label={props.ariaLabel}
    />
  )
}
